import { render } from "./EmployeeShow.vue?vue&type=template&id=6fabdaf5"
import script from "./EmployeeShow.vue?vue&type=script&lang=js"
export * from "./EmployeeShow.vue?vue&type=script&lang=js"

import "./EmployeeShow.vue?vue&type=style&index=0&id=6fabdaf5&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__